import { render, staticRenderFns } from "./ObjectCardComments.vue?vue&type=template&id=6029e746&scoped=true&"
import script from "./ObjectCardComments.vue?vue&type=script&lang=js&"
export * from "./ObjectCardComments.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCardComments.vue?vue&type=style&index=0&id=6029e746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6029e746",
  null
  
)

export default component.exports